import styled from 'styled-components';
import Label from '../../../_shared/components/Label';

export const Container = styled.div`
  display: flex;
  margin-top: 42px;
`;

export const VerticalSeparator = styled.div`
  border-left: solid 1px ${({ theme }) => theme.COLORS.NEUTRAL_10};
  margin: 0px 20px;
`;

export const Column = styled.div`
  flex: 0 0
    calc(
      ${props => 100 / props.numberOfColumns}% -
        ${props => (props.numberOfColumns - 1) * 20}px
    );
`;

export const StyledLabel = styled(Label)`
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
`;
